import axios from './axios.interceptors';

class AgencyService {
  public submitAgencyApplication = async (formData: any, files: File[]): Promise<any> => {
    try {
      const form = new FormData();

      const requestData = {
        travelAgencyName: formData.travelAgencyName,
        taxNumber: formData.taxNumber,
        taxOffice: formData.taxOffice,
        tradeRegisterNumber: formData.tradeRegisterNumber,
        address: formData.address,
        city: formData.city,
        contactPerson: formData.contactPerson,
        country: formData.country,
        mobileNumber: formData.mobileNumber,
        email: formData.email,
      };

      form.append(
        "request",
        new Blob([JSON.stringify(requestData)], { type: "application/json" })
      );
      

      if (files && files.length > 0) {
        files.forEach((file) => {
          form.append("businessCertificate", file);
        });
      }

      const response = await axios.post(
        "/api/agents/agency-applications",
        form,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      return response.data;
    } catch (err) {
      console.error("Agency application error:", err);
      throw err;
    }
  };
}

export default new AgencyService();
